import {createSelector} from 'reselect';
import {RootState} from 'typesafe-actions';
import {ElectionState} from './reducer';
import {
  ICompetitor,
  IElection,
  IElectionConfigs,
  IPlate,
  IPlateData,
  IPlateDetail,
  IRound,
  IVoting,
  PlateVoteStatusEnum,
} from './types';
import IInfo = MyTypes.IInfo;

export const electionSelector = (state: RootState): ElectionState =>
  state.election;

export const getElection = createSelector<any, any, IElection | null>(
  electionSelector,
  (state: ElectionState) => state.model
);

export const getElectionInfo = createSelector<any, any, IInfo>(
  electionSelector,
  (state: ElectionState) => state.info
);

export const getElectionConfigs = createSelector<
  any,
  any,
  IElectionConfigs | null
>(
  electionSelector,
  (state: ElectionState) => state.model && state.model.configs
);

// PLATES SELECTORS
export const getPlates = createSelector<any, any, IPlate[]>(
  electionSelector,
  (state: ElectionState) => state.plates || []
);

export const getPlatesOpened = createSelector<any, any, IPlate[]>(
  getPlates,
  (plates: IPlate[]) => {
    return plates.filter(item => {
      return item.status === PlateVoteStatusEnum.OPEN;
    });
  }
);

const closedStatus = [PlateVoteStatusEnum.UNDO, PlateVoteStatusEnum.VOTED];
export const getPlatesClosed = createSelector<any, any, IPlate[]>(
  getPlates,
  (plates: IPlate[]) => {
    return plates.filter(item => closedStatus.includes(item.status));
  }
);

// CURRENT PLATE SELECTORS
export const getPlateDetail = createSelector<any, any, IPlateDetail | null>(
  electionSelector,
  (state: ElectionState) => state.currentPlate || null
);

export const getPLateData = createSelector<any, any, IPlateData | null>(
  getPlateDetail,
  (data: IPlateDetail) => (data && data.plate ? data.plate : null)
);

export const getRound = createSelector<any, any, IRound | null>(
  getPlateDetail,
  (data: IPlateDetail) => (data && data.round ? data.round : null)
);

export const getCompetitors = createSelector<any, any, ICompetitor[]>(
  getPlateDetail,
  (data: IPlateDetail) => (data && data.competitors ? data.competitors : [])
);

// VOTE SELECTORS
export const getVoteResult = createSelector<any, any, IVoting | null>(
  electionSelector,
  (state: ElectionState) => state.vote || null
);



// WEBPACK FOOTER //
// ./src/features/election/store/selectors.ts